'use client'

import React from 'react'
import { useTranslations } from 'next-intl'

import type { HolidayPackagesIndexEntry } from '@/src/types/holidays'
import useHolidayPackagesList from '@/src/hooks/holidays/useHolidayPackagesList'
import ErrorBoundaryWrapper from '@/src/containers/common/ErrorBoundary'

import HolidayPackagesDesktopPage from './packages'

interface HolidayPackagesDesktopContainerProps {
    entries: HolidayPackagesIndexEntry[]
    domainCountry: string
}

const HolidayPackagesDesktopContainer: React.FC<HolidayPackagesDesktopContainerProps> = ({
    entries,
    domainCountry
}) => {
    const t = useTranslations('holidaysPage')
    const list = useHolidayPackagesList(entries)

    return (
        <ErrorBoundaryWrapper identifier="holidays-packages-desktop">
            <HolidayPackagesDesktopPage
                heading={t('packagesHeading')}
                breadcrumbLabel={t('packagesBreadcrumb')}
                resultCountLabel={t('packagesAvailable', { count: list.visiblePackages.length })}
                emptyTitle={t('packagesEmptyTitle')}
                emptyBody={t('packagesEmptyBody')}
                clearAllLabel={t('filtersClearAll')}
                packages={list.visiblePackages}
                cityFacets={list.cityFacets}
                monthFacets={list.monthFacets}
                occasionFacets={list.occasionFacets}
                themeFacets={list.themeFacets}
                filters={list.filters}
                totalPackages={list.totalPackages}
                hasActiveFilters={list.hasActiveFilters}
                sort={list.sort}
                onSortChange={list.setSort}
                onToggleCity={list.toggleCity}
                onToggleMonth={list.toggleMonth}
                onToggleOccasion={list.toggleOccasion}
                onToggleTheme={list.toggleTheme}
                onApplySearch={list.applySearch}
                onClearAll={list.clearAll}
                domainCountry={domainCountry}
            />
        </ErrorBoundaryWrapper>
    )
}

export { HolidayPackagesDesktopContainer }
export default HolidayPackagesDesktopContainer
